import { MDText } from 'i18n-react';

import type { ToastProps } from '@motorway/mw-highway-code/pre-alpha';
import { toast } from '@motorway/mw-highway-code/pre-alpha';

import useMakesStore from 'Stores/MakesStore/MakesStore';
import type { MakesStore } from 'Stores/MakesStore/MakesStore.types';
import useModelsStore from 'Stores/ModelsStore/ModelsStore';
import type { ModelsStore } from 'Stores/ModelsStore/ModelsStore.types';
import type { Makes } from 'Types/make';
import type { Model, Models } from 'Types/model';

import LocalTexts from '../Insights.texts';

import { checkMakeIsNotOther, checkModelIsNotOther } from './useGetMakesAndModels.helpers';

const LocalT = new MDText(LocalTexts);

const errorToastProps: ToastProps = {
	content: LocalT.translate(`error.toast.content`),
	heading: LocalT.translate(`error.toast.heading`),
	variant: 'error',
};
type MakesAndModels = {
	allModels?: ModelsStore['models'];
	getMakeById: MakesStore['getMakeById'];
	getMakeBySlug: MakesStore['getMakeBySlug'];
	makes?: Makes;
	models?: Models;
};

export const useMakesAndModels = (selectedMakeId?: number): MakesAndModels => {
	// TODO: Move this logic to useInsightsStore once in place
	const { getMakeById, getMakeBySlug, makes: allMakes } = useMakesStore((store) => store);

	const allModels = useModelsStore((store) => store.models);

	if (!allMakes || allMakes.length === 0 || !allModels || allModels.length === 0) {
		toast(errorToastProps);

		return { allModels, getMakeById, getMakeBySlug, makes: undefined, models: undefined };
	}

	const modelsWithoutOther: Model[] = [];
	const otherModels: Model[] = [];

	for (const model of allModels) {
		if (model.makeId === selectedMakeId) {
			if (checkModelIsNotOther(model.name)) {
				modelsWithoutOther.push(model);
			} else {
				otherModels.push(model);
			}
		}
	}
	modelsWithoutOther.sort((a, b) => a.name.localeCompare(b.name));
	otherModels.sort((a, b) => a.name.localeCompare(b.name));

	const makes = allMakes?.filter((make) => checkMakeIsNotOther(make.name));

	return { allModels, getMakeById, getMakeBySlug, makes, models: [...modelsWithoutOther, ...otherModels] };
};
